import { useMutation } from '@apollo/react-hooks';

import { verifyClassroom as CR_VERIFY_CLASSROOM } from '../../GraphQL/mutation/Classroom.mutation';

const useVerfiyClassroom = (props) => {
  const [verifyClassroom, { data, error, loading, ...apolloUtils }] = useMutation(
    CR_VERIFY_CLASSROOM,
    props
  );

  const handleVerifyClassroom = ({ classroomCourseId }) => {
    return verifyClassroom({
      variables: { classroomId: classroomCourseId },
      skip: !classroomCourseId,
      ...props,
    });
  };

  return {
    verifyClassroom: handleVerifyClassroom,
    loading,
    error,
    data,
    ...apolloUtils,
  };
};
export default useVerfiyClassroom;
